import axios from "axios";
import {INVOICE_API_URL, REMITTANCE_API_URL} from "../constants/api_routes";
import {getHeader} from "./user_api";

export const getRemittances = async (startDate,endDate) => {
    try {
        if(startDate && endDate){
            return await axios.get(`${REMITTANCE_API_URL}/list?start_date=${startDate}&end_date=${endDate}`, {headers: getHeader()});
        }
        else{
            return await axios.get(`${REMITTANCE_API_URL}/list`, {headers: getHeader()});
        }
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const getRemittanceEstimateList = async () => {
    try {
        return await axios.get(`${REMITTANCE_API_URL}/estimates/list`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const getRemittanceDetail = async (id) => {
    try {
        return await axios.get(`${REMITTANCE_API_URL}/detail?remittance_id=${id}`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const getEstimateDetails = async (id) => {
    try {
        return await axios.get(`${REMITTANCE_API_URL}/estimates/detail?estimate_id=${id}`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};


export const changeRemittanceStatus = async (formData) => {
    try {
        return await axios.post(`${REMITTANCE_API_URL}/update_status`,formData, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};


export const updateAdjustment = async (formData,actionType) => {
    try {
        return await axios.post(`${REMITTANCE_API_URL}/adjustments/${actionType}`,formData, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const deleteAdjustment = async (adjustmentId) => {
    try {
        return await axios.delete(`${REMITTANCE_API_URL}/adjustments/delete?remittance_adjustment_id=${adjustmentId}`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const regenerateRemittance = async (remittanceId) => {
    try {
        return await axios.post(`${REMITTANCE_API_URL}/regenerate_remittance`,{remittance_id:remittanceId},{headers:getHeader()});
    }
    catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const sendRemittanceMail = async (remittanceId) => {
    try {
        return await axios.post(`${REMITTANCE_API_URL}/send_email`,{remittance_id:remittanceId},{headers:getHeader()});
    }
    catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};


// WEBPACK FOOTER //
// ./src/data/account_remittance_api.js